import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';
import {
  ExtractTestsPaginatedResponse,
  GetAdminExtractFiltersResponse,
  ExtractTestsPaginatedPayload
} from '../interfaces/history.interface';

const BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/api/history`;

export const historyApi = createApi({
  reducerPath: 'historyApi',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['ExtractTestsPaginated', 'ExtractDataFilters'],
  endpoints: (build) => ({
    extractTestsPaginated: build.query<ExtractTestsPaginatedResponse, ExtractTestsPaginatedPayload>({
      providesTags: ['ExtractTestsPaginated'],
      query: (body) => ({
        url: '/extract-tests-paginated',
        method: 'POST',
        body
      })
    }),
    getAdminExtractFilters: build.query<GetAdminExtractFiltersResponse, void>({
      query: () => '/extract-tests-filters',
      providesTags: ['ExtractDataFilters'],
      transformResponse: (response: GetAdminExtractFiltersResponse): GetAdminExtractFiltersResponse => {
        if (!response?.filters) {
          return { filters: [] };
        }
        return response;
      }
    })
  })
});

export const { useLazyExtractTestsPaginatedQuery, useGetAdminExtractFiltersQuery } = historyApi;
